import * as React from 'react';

import classnames from 'classnames';

import styles from './button-group.module.css';

type Props = {
    children: React.ReactNode;
    style?: any;
    flexWrap?: {
        justifyContent: 'start' | 'end';
    };
    spacing?: 4 | 8 | 16;
    alignItems?: 'start' | 'end' | 'center';
};

export function ButtonGroup(props: Props) {
    const {spacing = 8, alignItems = 'center'} = props;

    const styleName = classnames(styles['button-group'], {
        [styles['button-group--align-start']]: alignItems === 'start',
        [styles['button-group--align-end']]: alignItems === 'end',
        [styles['button-group--align-center']]: alignItems === 'center',
        [styles['button-group--flex-shrink']]: !props.flexWrap,
        [styles['button-group--flex-wrap']]: props.flexWrap,
        [styles['button-group--flex-wrap-end']]:
            props.flexWrap && props.flexWrap.justifyContent === 'end',
        [styles['button-group--flex-wrap-start']]:
            props.flexWrap && props.flexWrap.justifyContent === 'start',
    });

    return (
        <div style={props.style} className={classnames(`gap-${spacing}`, styleName)}>
            {props.children}
        </div>
    );
}
